export const ADDRESS = 'address';
export const NAME = 'name';
export const COMPANY = 'company';
export const ID_NUMBER = 'id_number';
export const STRINGS = 'strings';

// source of truth for signals is inscribe-app/results/utils/result_type.py

export const ADDRESS_FORMAT_ANOMALY = 'address_format_anomaly';
export const ADOBE_FONTS = 'adobe_fonts';
export const AI_GENERATED = 'ai_generated';
export const AMOUNT_FORMAT_ANOMALY = 'amount_format_anomaly';
export const ANNOTATION_DATES = 'annotation_dates';
export const ANNOTATIONS = 'annotations';
export const BLOCKLISTS = 'blacklists';
export const BRUSH_DETECTION = 'brush_detection';
export const COPYCAT_IMAGE = 'copycat_image';
export const COPYCAT_TEXT = 'copycat_text';
export const CUSTOM_RULES = 'rules';
export const DATE_FORMAT_ANOMALY = 'date_format_anomaly';
export const DATE_METADATA = 'date_metadata';
export const DATES_MISMATCH = 'dates_mismatch';
export const DOCSTORE_TEMPLATE = 'docstore_template';
export const EDITED_TEXT = 'edited_text';
export const EDITED_WHILE_SCANNED = 'edited_while_scanned';
export const EXIF_DATA_MODIFIED = 'exif_data_modified';
export const EXPECTED_CREATION_DATE = 'expected_creation_date';
export const EXPECTED_IMAGE_METADATA = 'expected_image_metadata';
export const FINGERPRINT = 'fingerprint';
export const FLATTENED_PDF = 'flattened_pdf';
export const FONT_ANOMALY = 'font_anomaly';
export const FONTS = 'fonts';
export const GENERIC_DATA = 'generic_data';
export const HIGH_RISK_CUSTOMER_SEEN_BEFORE = 'high_risk_customer_seen_before';
export const HIGH_USER_ACCESS = 'high_user_access';
export const IMAGE_SIZE_MATCH = 'image_size_match';
export const INCOGNITO_MODE = 'incognito_mode';
export const INCONSISTENT_EIN = 'inconsistent_ein';
export const IS_NOT_BALANCED = 'transactions_do_not_balance';
export const ISSUED_AS_IMP = 'issued_as_imp';
export const MALFORMED_DATE = 'malformed_date';
export const MASKING = 'masking';
export const MASKING_LIMITED = 'masking_key_details';
export const METADATA_ANOMALY = 'metadata_anomaly';
export const NAME_FORMAT_ANOMALY = 'name_format_anomaly';
export const NO_DATE = 'no_date';
export const OVERLAID_TEXT = 'overlaid_text';
export const PAYSLIP_INVALID_DATES = 'payslip_invalid_dates';
export const PAYSLIP_MISCALCULATION = 'payslip_miscalculation';
export const PDF_ALIGNMENT = 'pdf_alignment';
export const QPDF = 'qpdf';
export const REJECTED_CUSTOMER = 'rejected_customer';
export const REPEAT_ACCOUNT_NUMBER = 'repeat_account_number';
export const REPEAT_APPLICATION = 'repeat_application';
export const REPEAT_APPLICATION_DIFFERENT_ADDRESS =
  'repeat_application_different_address';
export const REPEAT_APPLICATION_DIFFERENT_NAME =
  'repeat_application_different_name';
export const REPEAT_APPLICATION_PREVIOUS_FRAUD =
  'repeat_application_previous_fraud';
export const REPEAT_APPLICATION_PREVIOUS_REJECTION =
  'repeat_application_previous_rejection';
export const REPEAT_BALANCES = 'repeat_balances';
export const SEEN_BEFORE = 'seen_before';
export const SOFTWARE_BLOCKLIST = 'software_blacklist';
export const STRIPPED_METADATA = 'stripped_metadata';
export const SUMMARY_NOT_BALANCED = 'summary_not_balanced';
export const SUSPICIOUS_PDF_METADATA = 'suspicious_pdf_metadata';
export const SUSPICIOUS_PDF_OWNER = 'suspicious_pdf_owner';
export const TEMPLATES = 'templates';
export const TEXT_ALIGNMENT = 'text_alignment';
export const TEXT_COMPRESSION = 'text_compression';
export const TEXT_LAYER_TEXT = 'text_layer_text';
export const TOUCHUP_TEXT = 'touchup_text';
export const XRAY = 'xray';
export const XRAY_LIMITED = 'xray_key_details';
export const BANK_CHARGE_IDENTIFIED = 'bank_charge_identified';
export const CRYPTO_TRADING_IDENTIFIED = 'crypto_trading_identified';
export const GAMBLING_IDENTIFIED = 'gambling_identified';
export const LOANS_IDENTIFIED = 'loans_identified';
export const UNUSUAL_ROUND_NUMBER_DISTRIBUTION =
  'unusual_round_number_distribution';
export const PDF_STRUCTURE_ANOMALY = 'pdf_structure_anomaly';
export const SHARPNESS_INCONSISTENCY = 'sharpness_inconsistency';
export const W2_SOCIAL_SECURITY_LIMIT_EXCEEDED =
  'w2_social_security_limit_exceeded';
export const CONTENT_OVERLAY = 'content_overlay';

export const SEVERITY_LEVEL = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  TRUST: 'TRUST',
};

export function severityLevelToReadableLabel(severityLevel) {
  switch (severityLevel) {
    case SEVERITY_LEVEL.HIGH:
      return 'High Severity';
    case SEVERITY_LEVEL.MEDIUM:
      return 'Medium Severity';
    case SEVERITY_LEVEL.LOW:
      return 'Low Severity';
    default:
      return severityLevel;
  }
}

export function severityLevelToDescription(severityLevel) {
  switch (severityLevel) {
    case SEVERITY_LEVEL.HIGH:
      return 'Significant issues that can indicate fraud.';
    case SEVERITY_LEVEL.MEDIUM:
      return 'Moderate issues that sometimes indicate fraud.';
    case SEVERITY_LEVEL.LOW:
      return 'Less serious issues that occasionally indicate fraud.';
    default:
      return severityLevel;
  }
}
